export default (func, wait = 0) => {
	// Returns a function which will start a timeout to perform an operation... unless it's cancelled
	let inst;

	return (...args) => {
		if (inst) {
			clearTimeout(inst);
		}
		inst = setTimeout(func.bind(null, ...args), wait);
	};
};
